import React from 'react';
import {
  Box,
  Button,
  Divider,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

/**
 * Dense MUI shell for element editors in the ScriptEdit sidebar.
 * Keeps spacing and typography consistent without legacy `.sidebar-form` styles.
 */
export default function ScriptEditSidebarForm({
  title,
  iconClass,
  displayName = '',
  onDisplayNameChange,
  prompt,
  onPromptChange,
  showPrompt = true,
  multilinePrompt = false,
  promptRows = 8,
  namePlaceholder = 'Use something descriptive',
  errMsg,
  onSubmit,
  onCancel,
  onDeleteElement,
  showDelete = false,
  children,
}) {
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit?.();
  };

  return (
    <Stack
      component="form"
      spacing={1.25}
      className="script-edit-element-form"
      onSubmit={handleSubmit}
      noValidate
    >
      <Divider />
      <Stack direction="row" spacing={1} alignItems="center">
        {!!iconClass && (
          <Box component="i" className={iconClass} sx={{ fontSize: '0.9rem', opacity: 0.85 }} />
        )}
        <Typography variant="subtitle2" color="secondary.main" sx={{ fontWeight: 600 }}>
          {title}
        </Typography>
      </Stack>

      {!!errMsg && (
        <Typography variant="caption" color="error">
          {errMsg}
        </Typography>
      )}

      {!!onDisplayNameChange && (
        <TextField
          fullWidth
          size="small"
          label="Name"
          placeholder={namePlaceholder}
          value={displayName}
          onChange={(e) => onDisplayNameChange(e.target.value)}
          variant="outlined"
        />
      )}

      {showPrompt && !!onPromptChange && (
        <TextField
          fullWidth
          size="small"
          label="Prompt"
          value={prompt || ''}
          onChange={(e) => onPromptChange(e.target.value)}
          multiline={multilinePrompt}
          minRows={multilinePrompt ? promptRows : undefined}
          variant="outlined"
        />
      )}

      {children}

      <Stack spacing={1}>
        <Button type="submit" variant="contained" color="primary" fullWidth>
          Submit
        </Button>
        {!!onCancel && (
          <Button
            type="button"
            variant="outlined"
            color="secondary"
            fullWidth
            onClick={onCancel}
          >
            Cancel
          </Button>
        )}
        {showDelete && !!onDeleteElement && (
          <Button
            type="button"
            variant="outlined"
            color="error"
            fullWidth
            onClick={onDeleteElement}
          >
            Delete Element
          </Button>
        )}
      </Stack>
    </Stack>
  );
}
